<template>
  <div id="app">
    <router-view></router-view>

    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
html {
  font-size: calc(3px + 1vw); /* 基础字体大小加上视口宽度的1% */
}
@media screen and (max-width: 768px) {
  html {
    font-size: 1vw;
  }
}

/* 限制最大字体大小 */
@media screen and (min-width: 1200px) {
  html {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue